<template>
  <base-alert v-if="failed && isValidated" class="text-center" type="danger">
    <div>There are questions which require responses before proceeding.</div>
    <div>The unanswered questions are highlighted above.</div>
  </base-alert>
</template>
<script>
import { BaseAlert } from '../../components';

export default {
  components: {
    BaseAlert
  },
  props: {
    failed: {
      type: Boolean,
      required: true,
      default: false
    },
    isValidated: {
      type: Boolean,
      required: true,
      default: false
    }
  }
}
</script>
